import * as React from 'react';

import * as roughEdge from '../../../../images/homepage/rough-edge.png';
import * as roughEdge3 from '../../../../images/homepage/rough-edge-3.png';

export default function RoughEdgeSection({ children }) {
  return (
    <section>
      <div
        className="rough-edge__border-image"
        style={{ backgroundImage: `url('${roughEdge}')` }}
      />
      <div className="bg-white bg--darken pt-1 pb-3">
        {...children}
      </div>
      <div
        className="rough-edge__border-image"
        style={{ backgroundImage: `url('${roughEdge3}')` }}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/rough_edge_section.tsx